export const prohibitedItems = [
  [
    "Ծխախոտ և ծխախոտի փոշի",
    "Միս և մսամթերք",
    "Ձկնամթերք և այլ ծովամթերք",
    "Կաթ և կաթնամթերք",
    "Մետաղադրամներ, թղթադրամներ կամ վճարման ենթակա այլ արժեթղթեր, ճամփորդական չեկեր, պլատին, ոսկի, արծաթ (ինչպես անմշակ, այնպես էլ դրանցից պատրաստված իրեր), թանկարժեք քարեր, զարդեր և այլ թանկարժեք իրեր",
    "Լիթիումի մարտկոցներ (ինչպես առանձին ներկայացված, այնպես էլ սարքավորումներում տեղադրված)",
    "Կեղծ և «ծովահեն» ապրանքներ",
    "Կոպիտ կամ անբարոյական բնույթ կրող իրեր",
    "Թմրամիջոցներ և հոգեմետ նյութեր",
    "Անօրինական նյութեր, որոնք արգելված են Թմրամիջոցների վերահսկման միջազգային կոմիտեի սահմանման համաձայն կամ այլ նպատակակետ երկրի կողմից",
    "Ընթացիկ կամ անձնական նամակագրություն պարունակող փաստաթղթեր, որոնցում փոստային առաքանին ուղարկողը կամ նրա հետ ապրող անձինք չեն հանդիսանում որպես ուղարկողներ",
    "Այն իրերը, որոնք իրենց բնույթով կամ փաթեթավորմամբ կարող են վտանգել փոստային բաժանմունքի աշխատակիցներին կամ համայնքին, աղտոտել կամ վնասել այլ փոստային առաքանիները, փոստային սարքավորումները կամ երրորդ կողմին պատկանող գույքը",
    "Իներտ պայթուցիկ սարքեր և զինամթերք, ներառյալ իներտ հրթիռներ և պարկուճներ և նմանատիպ այլ իրեր, ինչպես նաև կեղծիքներ կամ նման սարքեր և իրեր",
    "Ռադիոակտիվ նյութեր",
    "Վարակ պարունակող նյութեր",
    "Այլ իրեր և նյութեր, որոնց շնորհվում է վտանգավոր ապրանքների կարգավիճակ՝ համաձայն գործող օրենսդրության",
    "Այլ ապրանքներ, որոնց ներմուծելը և տարածելը արգելված է հասցեատիրոջ երկրում"
  ],
  [
    "Табак и табачные изделия",
    "Мясо и мясные продукты",
    "Рыба и другие морепродукты",
    "Молоко и молочные продукты",
    "Монеты, банкноты или другие оборотные документы, дорожные чеки, платина, золото, серебро (как необработанное, так и изготовленное из него), драгоценные камни, ювелирные изделия и другие ценности",
    "Литиевые батареи (как отдельно поставляемые, так и установленные в оборудовании)",
    "Фальшивая и «пиратская» продукция",
    "Предметы грубого или безнравственного характера",
    "Наркотические и психотропные вещества",
    "Незаконные вещества, запрещенные Международным комитетом по контролю над наркотиками или другой страной назначения.",
    "Документы, содержащие личные переписки, в которых отправитель или лица, проживающие с ним/ней, не указаны в качестве отправителей.",
    "Предметы, которые по своему характеру или упаковке могут представлять опасность для сотрудников почтового отделения или общества, загрязнять или портить другие почтовые отправления, почтовое оборудование или имущество третьих лиц.",
    "Инертные взрывные устройства и боеприпасы, включая инертные ракеты, снаряды и другие аналогичные предметы, а также поддельные предметы и устройства",
    "Радиоактивные материалы",
    "Инфекционные вещества",
    "Другие предметы и вещества, которым в соответствии с действующим законодательством присвоен статус опасных грузов.",
    "Другие товары, ввоз и распространение которых запрещены в стране-получателе."
  ],
  [
    "Leki",
    "Alkohol",
    "Tytoń i tytoń w proszku",
    "Mięso i produkty mięsne",
    "Ryby i inne owoce morza",
    "Mleko i produkty mleczne",
    "Monety, banknoty lub inne płatne papiery wartościowe, czeki podróżne, platyna, złoto, srebro (zarówno w stanie surowym, jak i wyroby z nich), kamienie szlachetne, biżuteria i inne kosztowności",
    "Baterie litowe (zarówno prezentowane oddzielnie, jak i instalowane w sprzęcie)",
    "Produkty podrabiane i pirackie",
    "Rzeczy brutalne i o charakterze niemoralnym",
    "Narkotyki i substancje psychoaktywne",
    "Nielegalne substancje zabronione przez Międzynarodowy Organ Kontroli Środków Odurzających lub inny kraj docelowy",
    "Dokumenty zawierające bieżącą lub osobistą korespondencję, w którym nadawca przesyłki kurierskiej lub osoby z nim mieszkające nie są nadawcami",
    "Przesyłki, które ze względu na swój charakter lub opakowanie mogą stanowić zagrożenie dla pracowników urzędu pocztowego lub społeczności, zanieczyszczać lub uszkadzać inne przesyłki pocztowe, sprzęt pocztowy lub mienie należące do osoby trzeciej",
    "Inertne urządzenia wybuchowe i amunicja, w tym rakiety i pociski inertne oraz podobne artykuły, a także podrobione wyroby lub podobne urządzenia i artykuły",
    "Materiały radioaktywne",
    "Substancje zakaźne",
    "Inne przedmioty i materiały, którym przypisano status towarów niebezpiecznych zgodnie z obowiązującymi przepisami",
    "Inne produkty, których import i dystrybucja są zabronione w kraju przeznaczenia"
  ],
  [
    "Medicines",
    "Meat and meat products",
    "Fish and other seafood",
    "Milk and dairy products",
    "Coins, notes or other securities payable, traveller's cheques, platinum, gold, silver (both unwrought and articles thereof), precious stones, jewelery and other valuables",
    "Lithium batteries (both separately presented and installed in equipment)",
    "Counterfeit and pirated products",
    "Crude or obscene material",
    "Narcotics and psychoactive substances",
    "Illegal substances prohibited by the International Narcotics Control Board or other destination country",
    "Documents containing routine or personal correspondence in which the sender or persons living with the courier are not the senders",
    "Items that, by their nature or packaging, may endanger post office employees or the community, contaminate or damage other mail items, postal equipment, or third-party property.",
    "Inert explosive devices and munitions, including inert rockets and shells and similar articles, as well as counterfeit or similar devices and articles",
    "Restricted products",
    "Infectious substances",
    "Other items and materials that are assigned the status of dangerous goods according to the applicable legislation",
    "Other products, the importation and distribution of which is prohibited in the country of destination"
  ],
];

export const restrictedItems = [
  [
    {
      title: "Սուրճ",
      description: "(ոչ ավել քան 1 կգ)",
    },
    {
      title: "Թեյ",
      description: "(մինչև 0,5 կգ)",
    },
    {
      title: "Չիր",
      description: "(մինչև 5 կգ)",
    },
    {
      title: "Քաղցրավենիք",
      description: "(մինչև 5 կգ)",
    },
    {
      title: "Մեղր",
      description: "(մինչև 0,5 կգ)",
    },
    {
      title: "Չորացրած կանաչի և համեմունքներ",
      description: "(յուրաքանչյուրը մինչև 1 կգ)",
    },
    {
      title: "Պահածոներ՝ գործարանային փաթեթավորմամբ",
      description: "մինչև 3 կգ",
    },
    {
      title: "Օծանելիք",
      description: "(2 սրվակ , (մինչև 150 մլ))"
    }
  ],
  [
    {
      title: "Кофе, чай, специи",
      description: "(до 5 кг)",
    },
    {
      title: "Сахар и кондитерские изделия из сахара",
      description: "(до 10 кг)",
    },
    {
      title: "Печенье (сухое сладкое)",
      description: "(до 5 кг)",
    },
    {
      title: "Мед",
      description: "(до 0,5 кг)",
    },
    {
      title: "Пищевые добавки",
      description: "(до 3 кг)",
    },
    {
      title: "Детское питание",
      description: "(до 5 кг)",
    },
    {
      title: "Напитки",
      description: "*любое количество подлежит растаможке",
    },
    {
      title: "Одежда, предметы одежды и аксессуары",
      description: "(до 10 кг в общей сложности /не более 2 единиц одной одежды/)"
    },
    {
      title: "Одежда и текстильные изделия, бывшие в употреблении",
      description: "(до 20 кг)"
    },
    {
      title: "Одежда и ее принадлежности (включая перчатки)",
      description: "(до 5 пар)"
    },
    {
      title: "Натуральный и искусственный мех, а также изделия из него",
      description: "(3 шт)"
    },
    {
      title: "Обувь",
      description: "(4 пары)"
    },
    {
      title: "Косметика, средства для макияжа и ухода за кожей (кроме лекарственных средств), включая средства от или против солнечных ожогов, средства для маникюра и педикюра",
      description: "по 4 наименования из каждой товарной позиции"
    },
    {
      title: "Духи",
      description: "(до 3 штук каждого вида (общим объемом не более 200 мл))"
    },
    {
      title: "Лекарства",
      description: "(5 наименований по 3 пачки каждого на 1 год, *Предупреждение. Вы не можете добавлять дополнительное количество в пачку!!!)"
    },
    {
      title: "Игрушки, игры и спортивный инвентарь, их части и принадлежности",
      description: "(4 шт)"
    },
    {
      title: "Готовый корм для животных",
      description: "( до 10 кг)"
    }
  ],
  [
    {
      title: "Kawa",
      description: "(nie więcej niż 1 kg)",
    },
    {
      title: "Herbata",
      description: "(do 0,5 kg)",
    },
    {
      title: "Sweet, dry biscuits",
      description: "(up to 5 kg)",
    },
    {
      title: "Suszone owoce",
      description: "(do 5 kg)",
    },
    {
      title: "Słodycze",
      description: "(do 5 kg)",
    },
    {
      title: "Miód",
      description: "(do 0,5 kg)",
    },
    {
      title: "Suszone zioła i przyprawy",
      description: "(do 1 kg każde)",
    },
    {
      title: "Puszki z opakowaniem fabrycznym",
      description: "(do 3 kg)",
    },
    {
      title: "Perfumy",
      description: "(2 butelki (do 150 ml))",
    },
  ],
  [
    {
      title: "Coffee, tea, spices",
      description: "(up to 5 kg)",
    },
    {
      title: "Sugar and sugar confectionery",
      description: "(up to 10 kg)",
    },
    {
      title: "Sweet, dry biscuits",
      description: "(up to 5 kg)",
    },
    {
      title: "Honey",
      description: "(up to 0.5 kg)",
    },
    {
      title: "Food additives",
      description: "(up to 3 kg)",
    },
    {
      title: "Baby food",
      description: "(up to 5 kg)",
    },
    {
      title: "Beverage",
      description: "any quantity subject to customs clearance",
    },
    {
      title: "Clothing, clothing items and accessories",
      description:
        "general up to 10 kg / no more than 2 pieces of the same clothing/",
    },
    {
      title: "Clothing and textile products previously used",
      description: "up to 20 kg",
    },
    {
      title: "Clothing and its accessories (including gloves)",
      description:
        "up to 5 pairs",
    },
    {
      title: "Natural and artificial fur, articles from it",
      description:
        "3 different",
    },
    {
      title: "Footwear",
      description:
        "4 pairs",
    },
    {
      title: "Cosmetic, make-up and skin care preparations (other than medicinal products), including tanning or anti-tanning preparations, manicure and pedicure preparations",
      description:
        "4 of each product subheading",
    },
    {
      title: "Perfume",
      description: "(up to 3 pieces of each, total no more than 200ml)",
    },
    {
      title: "Medicines",
      description: "5 names of products for 1 year, 3 boxes of each. Warning. no extra quantity can be added to the box",
    },
    {
      title: "Toys, games and sports equipment, their parts and accessories",
      description: "4 pcs",
    },
    {
      title: "Ready food for animals",
      description: "(up to 10 kg)",
    },
  ],
];